import React from 'react'
import { Link } from 'react-router-dom'

import { DeemphasizedLink, MembershipTypeLabel, Text } from '@fielded/shared-ui'
import { ArrowRightLeft } from '@fielded/shared-ui/src/icons'

import DueBalanceWidget from '../../van-shared/components/DueBalanceWidget'

// TODO: replace by real data
// This is from the example that api PR gave
const impersonatedUserMock = {
  'uuid': 'a1b2c3d4-0000-greenlife',
  'name': 'Greenlife Pharmacy',
  'market': 'ng',
  'marketId': 'market:lagos',
  'state': 'lagos',
  'membershipType': 'basic',
  'availableCashBalance': 412900,
  'availableCreditBalance': 0,
  'loanLimit': 0,
  'dueAmount': 68400,
  'creditCustomer': false,
  'isPaused': false
}

const ImpersonationBanner = () => {
  // TODO: replace with real data from impersonated user
  const membershipType = impersonatedUserMock.membershipType
  const userName = impersonatedUserMock.name
  return (
    <div className='impersonation-banner'>
      <div className='impersonation-banner__info'>
        <Text bold className='vs-u-row vs-u-gap-half'>
          <MembershipTypeLabel
            membershipType={membershipType}
            size='small'
            iconOnly
            isOnAccentColor
          />
          {userName}
        </Text>
        <DeemphasizedLink
          icon={<ArrowRightLeft />}
          size='small'
          bold
          component={Link}
          to={'/'}
        >
          Switch client
        </DeemphasizedLink>
      </div>
      <DueBalanceWidget
        userData={impersonatedUserMock}
        isOnDark
      />
    </div>
  )
}

export default ImpersonationBanner
